










import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';
import { QuestionModel } from '@/interfaces/registration/models/QuestionModel';

@Component
export default class QuestionInputTextArea extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
  @Prop({ default: () => { return {}; } }) readonly value!: QuestionModel;

  get model (): string {
    return this.value.value as string;
  }

  set model (newValue: string) {
    this.$emit('input', { id: this.formQuestion.id, value: newValue });
  }
}
